import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import SectorBenchmarks from "@/components/SectorBenchmarks";
import * as Icons from "lucide-react";

function Icon({ name, className }) { const C = Icons[name] || Icons.Circle; return <C className={className} />; }

export function Settori() {
  const [sectors, setSectors] = useState([]);
  useEffect(() => { api.get("/sectors").then(r => setSectors(r.data)); }, []);
  const cats = [...new Set(sectors.map(s => s.category))];
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <nav className="text-sm text-[#7A7788] mb-4"><Link to="/">Home</Link> · <span className="text-[#171522]">Settori</span></nav>
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">Tutti i settori supportati</h1>
      <p className="mt-4 text-lg text-[#524F5E] max-w-2xl">La struttura ATECO gerarchica di ImpresaChiara supporta oggi 9 attività reali e cresce mese dopo mese. Scegli il tuo per vedere KPI, benchmark e domande commerciali.</p>
      {cats.map(c => (
        <div key={c} className="mt-12">
          <p className="text-xs uppercase tracking-widest text-[#FF6A24] font-bold mb-4">{c}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {sectors.filter(s => s.category === c).map(s => (
              <Link key={s.slug} to={`/settori/${s.slug}`} className="ic-card p-6" data-testid={`sectors-list-${s.slug}`}>
                <Icon name={s.icon} className="w-6 h-6 text-[#5424D5] mb-4" />
                <h3 className="font-semibold text-lg">{s.name}</h3>
                <p className="text-sm text-[#524F5E] mt-1">{s.description}</p>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function SettoreDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/sectors/${slug}`).then(r => setS(r.data)).catch(()=>setS(false)); }, [slug]);
  if (s === false) return <div className="max-w-7xl mx-auto px-6 py-20">Settore non trovato.</div>;
  if (!s) return <div className="max-w-7xl mx-auto px-6 py-20">Caricamento…</div>;
  return (
    <div>
      <section className="border-b border-[#E5E4EB] bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <nav className="text-sm text-[#7A7788] mb-4"><Link to="/">Home</Link> · <Link to="/settori">Settori</Link> · <span className="text-[#171522]">{s.name}</span></nav>
          <div className="grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7">
              <p className="text-xs uppercase tracking-widest text-[#FF6A24] font-bold mb-3">{s.category} · ATECO {s.ateco}</p>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05]" data-testid="sector-hero-title">{s.hero_title}</h1>
              <p className="mt-6 text-lg text-[#524F5E] max-w-2xl">{s.hero_subtitle}</p>
              <div className="mt-8 flex flex-wrap gap-3">
                <Link to={`/business-check?sector=${s.slug}`} className="ic-btn-primary" data-testid="sector-cta">Analizza gratis la mia {s.name}</Link>
                <Link to="/pricing" className="ic-btn-ghost">Vedi i piani</Link>
              </div>
            </div>
            <div className="lg:col-span-5">
              <SectorBenchmarks slug={s.slug} />
            </div>
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-bold mb-8">Le domande commerciali che ti fai (o dovresti farti)</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {s.questions?.map((q,i) => (
            <div key={i} className="ic-card p-6">
              <p className="text-3xl text-[#FF6A24] font-extrabold">{String(i+1).padStart(2,'0')}</p>
              <p className="mt-3 text-base font-medium text-[#171522]">{q}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 p-8 ic-card bg-[#171522] text-white flex flex-wrap items-center justify-between gap-4">
          <div>
            <h3 className="text-2xl font-bold">Pronto a vedere i tuoi numeri?</h3>
            <p className="text-white/70">Il Business Check è gratuito. Ci vogliono 3 minuti.</p>
          </div>
          <Link to={`/business-check?sector=${s.slug}`} className="ic-btn-accent">Fai il Business Check</Link>
        </div>
      </section>
    </div>
  );
}
